<section class="bread-block">
  <div class="container">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['']">Головна</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/portfolio']">Портфоліо</a></li>
        <li class="breadcrumb-item">Торгово-розважальний центр «РЕСПУБЛІКА»</li>
      </ol>
    </nav>
  </div>
</section>

<section class="content-page my-2 my-lg-4">
  <div class="container">
    <div class="title title-zag-block">ТОРГОВЕЛЬНО-РОЗВАЖАЛЬНИЙ ЦЕНТР «РЕСПУБЛІКА»</div>
  </div>
</section>

<section class="slider">
  <div class="container">
    <div class="portfolio-owl owl-carousel owl-theme">
      <div class="slider-item">
        <img src="../../../../assets/images/respublica.jpg" alt="Торгово-развлекательный центр «РЕСПУБЛИКА»"
             class="img-fluid">
      </div>
    </div>
  </div>
</section>
<section class="content-page my-2 my-lg-4">
  <div class="container">
    <p>Торгово-розважальний центр «РЕСПУБЛІКА» 300 тис. м2 (м. Київ, вул. Окружна дорога).</p>
  </div>
</section>
<section class="content-page my-2 my-lg-4">
  <div class="container">
    <div class="title title-zag-block">Проведені роботи</div>
    <ol>
      <li>Монтаж систем холодопостачання та теплопостачання вентиляційного обладнання ВЕНТС (Україна) на базі
        обладнання Danfoss (Данія) та Wilo (Німеччина)
      </li>
    </ol>
  </div>
</section>

<app-our-advantages></app-our-advantages>
<app-our-clients-small></app-our-clients-small>
<app-feedback></app-feedback>
<app-map></app-map>
